import { Box, Grid, useTheme } from "@mui/material";
import AuthSideImg from "../../../assets/img-auth-sideimg.png";

const AuthWrapper = ({ children }) => {
  const theme = useTheme();
  return (
    <Box sx={{ minHeight: "100vh" }}>
      <Grid
        container
        direction="column"
        justifyContent="center"
        sx={{
          minHeight: "100vh",
          background: theme.palette.background.paper,
        }}
      >
        <Grid item xs={12}>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            alignItems="center"
            sx={{
              minHeight: {
                xs: "calc(100vh - 210px)",
                sm: "calc(100vh - 134px)",
                md: "calc(100vh - 112px)",
              },
            }}
          >
            <Grid
              item
              md={7}
              sx={{
                display: { xs: "none", md: "flex" },
                alignSelf: "center",
                justifyContent: "flex-start",
              }}
            >
              <img
                src={AuthSideImg}
                alt="Authimg"
                style={{
                  height: "100vh",
                  minHeight: "100%",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
            </Grid>
            <Grid
              item
              md={5}
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "56px",
              }}
            >
              {/* <AuthCard border={false}>{children}</AuthCard> */}
              {children}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuthWrapper;
